<template>
  <div class="page-content store-search">
    <el-dialog
      v-model="status.selectedModalVisible"
      class="selected-restaurants"
      title="Selected Restaurants"
      :before-close="beforeModalClose"
    >
      <div v-show="status.modalState === 'selected'">
        <el-table
          :data="selectedStores"
          border
          fit
          height="250"
          empty-text="No restaurants selected"
        >
          <el-table-column
            label="Menu?"
            width="85"
            align="center"
          >
            <template #default="scope">
              <el-checkbox
                v-model="selectedStores[scope.$index].printMenu"
                class="checkbox"
                :disabled="
                  selectedStores.filter((s: any) => s.printMenu).length >= maxAllowedMenus && !selectedStores[scope.$index].printMenu
                "
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="title"
            label="Restaurant"
          />
          <el-table-column
            v-for="(item, index) in printMenuServiceNames"
            :key="index"
            :label="item.shortName"
            width="65"
            align="center"
          >
            <template #default="scope">
              <el-checkbox
                class="checkbox"
                :checked="isPrintServiceSelected(scope.$index, item.longName)"
                :disabled="
                  (selectedStores.filter((s: any) => s.printMenu).length >= maxAllowedMenus && !selectedStores[scope.$index].printMenu) ||
                    !selectedStores[scope.$index].printMenu
                "
                @click="setPrintServiceSelected(scope.$index, item.longName)"
              />
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="100"
            align="left"
          >
            <template #default="scope">
              <el-button
                type="text"
                size="small"
                class=""
                align="left"
                @click.prevent="removeStore(scope.$index)"
              >
                Remove
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 10px">
          <p><b>Note:</b> A max of 10 restaurant menus is allowed.</p>
          <el-checkbox
            v-model="requestBody.printList"
            class="checkbox"
          >
            Include list of restaurants (1 page)
          </el-checkbox>
        </div>
      </div>

      <div v-show="status.modalState === 'send'">
        <customized-form
          id="printForm"
          v-loading="status.isLoadingPrint"
          class="form-vertical"
          :element-loading-text="status.loadingMessage"
          element-loading-custom-class="custom-spinner-class"
          @submit="onPrint"
        >
          <fieldset>
            <div class="row align-items-center">
              <el-checkbox
                v-model="status.selectedEmail"
                class="check-email"
                :disabled="!status.selectedMail"
              >
                Email Selection
              </el-checkbox>
              <el-checkbox
                v-model="status.selectedMail"
                class="check-mail"
                :disabled="!status.selectedEmail"
              >
                Mail Selection
              </el-checkbox>
            </div>
            <div class="row align-items-center">
              <label class="col-sm-3 control-label">First Name*</label>
              <div class="col-sm-9">
                <sanitized-input
                  v-model="requestBody.mailingAddress.firstName"
                  placeholder="Please input first name"
                  required
                />
              </div>
            </div>
            <div class="row align-items-center">
              <label class="col-sm-3 control-label no-padding-width">Last Name*</label>
              <div class="col-sm-9">
                <sanitized-input
                  v-model="requestBody.mailingAddress.lastName"
                  placeholder="Please input last name"
                  required
                />
              </div>
            </div>
          </fieldset>
          <fieldset v-if="status.selectedEmail">
            <div class="row">
              <label class="col-sm-3 control-label no-padding-width pt-10">Email*</label>
              <div class="col-sm-9">
                <email-input
                  v-model="requestBody.email"
                  required
                  @update-validation="updateEmailValidation"
                />
              </div>
            </div>
            <div class="row align-items-right">
              <el-checkbox
                v-model="status.accessibleEmail"
                class="check-include-restaurant"
              >
                Include restaurant list in email body (accessibility option for seeing impaired)
              </el-checkbox>
            </div>
          </fieldset>
          <fieldset v-if="status.selectedMail">
            <div class="row align-items-center">
              <label class="col-sm-3 control-label">Street Address*</label>
              <div class="col-sm-5">
                <address-autocomplete-input
                  id="streetAddress"
                  v-model="requestBody.mailingAddress.streetAddress"
                  :anchor-bound="anchorBound"
                  @place-changed="setAddressData"
                />
              </div>
              <label class="col-sm-1 control-label">Apt#</label>
              <div class="col-sm-3">
                <sanitized-input
                  v-model="requestBody.mailingAddress.streetAddress2"
                  placeholder="Apt number"
                />
              </div>
            </div>
            <div class="row align-items-center">
              <label class="col-sm-3 control-label">City*</label>
              <div class="col-sm-4">
                <sanitized-input
                  v-model="requestBody.mailingAddress.city"
                  required
                />
              </div>

              <label class="col-sm-2 control-label">State*</label>
              <div class="col-sm-3">
                <sanitized-input
                  v-model="requestBody.mailingAddress.state"
                  required
                />
              </div>
            </div>

            <div class="row align-items-center">
              <label class="col-sm-3 control-label">Zip*</label>
              <div class="col-sm-4">
                <sanitized-input
                  v-model="requestBody.mailingAddress.zip"
                  required
                />
              </div>
            </div>
          </fieldset>
          <message-html :result-html="status.resultHtml" />
        </customized-form>
      </div>

      <div
        v-show="status.modalState === 'sent'"
        class="sent-message"
      >
        {{ sentEmailMailText }}
      </div>

      <template #footer>
        <div class="d-flex justify-content-between">
          <div
            v-show="status.modalState !== 'sent'"
            class="text-left"
          >
            <p class="text-red font-weight-bold">
              Menus mailed on:
            </p>
            <p
              v-for="(item, index) in mailingsSentToCustomer"
              :key="index"
              class="text-red"
            >
              {{ util.formatDateTime(item.sentAt, 'MM/DD/YY') }}
            </p>
          </div>
          <div class="actions-wrapper">
            <el-button
              type="yellow"
              @click="
                status.selectedModalVisible = false;
                status.modalState = 'selected';
              "
            >
              Close
            </el-button>
            <el-button
              v-show="status.modalState === 'selected'"
              type="purple"
              @click="status.modalState = 'send'"
            >
              Mail List
            </el-button>
            <el-button
              v-show="status.modalState === 'send'"
              type="purple"
              form="printForm"
              native-type="submit"
            >
              Send&nbsp;&nbsp;<i class="fa fa-paper-plane-o" />
            </el-button>
          </div>
        </div>
      </template>
    </el-dialog>

    <div class="row search-form">
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <customized-form
              v-loading="status.isLoadingSearch"
              method="post"
              class="form-vertical"
              element-loading-text="Loading restaurants..."
              element-loading-custom-class="custom-spinner-class"
              autocomplete="off"
              @submit.prevent="onSearch"
            >
              <div class="align-items-center">
                <div class="">
                  <ordering-address
                    ref="deliveryAddressComponent"
                    v-model="deliveryAddress"
                    page-id="deliveryAddress"
                    class="mobile-mt-5"
                    :index="0"
                    :use-google-address="true"
                    :is-phone-number-valid="true"
                    :is-venues-search="false"
                    :is-geocode-show="true"
                    :is-intersection-form="false"
                    :is-swap-location="false"
                    :caller-info="customerInfo"
                    :is-custom-location-show="false"
                    map-pin-type="pickup"
                    @google-address="setDeliveryAddress"
                  >
                    <template #google-map>
                      <go-go-google-map
                        map-type-id="satellite"
                        class="mb-10 mt-10 mobile-mt-10"
                        :map-center="mapCenter"
                        :markers="[marker]"
                        :is-draggable="true"
                        :is-open-default="true"
                        :zoom="18"
                        @change="setMarkerPosition"
                        @drag-pin="dragMapPin"
                      />
                      <custom-location-buttons
                        v-if="!isDeliveryEstimate"
                        class="mt-20"
                        :caller-info="customerInfo"
                        :last-location-url="`callers/${customerInfo.id}/locationOfLastOrder`"
                        @change="onChooseCallerLocation"
                      />
                    </template>
                  </ordering-address>
                </div>
              </div>
              <div class="row align-items-center mt-20">
                <label
                  class="col-sm-3 control-label"
                  for="search-query"
                >Search</label>
                <div class="col-sm-7">
                  <sanitized-input
                    id="search-query"
                    v-model="searchQuery"
                    placeholder="(leave blank for local recommendations)"
                  />
                </div>
                <div
                  v-if="!isDeliveryEstimate"
                  class="search-settings"
                >
                  <el-checkbox-group
                    v-model="services"
                    class="d-flex mt-2"
                    type="text"
                  >
                    <div class="col-3">
                      <el-checkbox label="ubereats">
                        UberEats
                      </el-checkbox>
                    </div>
                    <div class="col-3">
                      <el-checkbox label="doordash">
                        DoorDash
                      </el-checkbox>
                    </div>
                  </el-checkbox-group>
                  <span class="search-settings__message"> Please <b>only</b> enable UberEats if unable to place order with DoorDash. </span>
                </div>
              </div>
              <message-html :result-html="status.resultHtml" />
              <div class="form-submit-button-group">
                <p-button
                  type="purple"
                  native-type="submit"
                >
                  Search
                </p-button>
                <p-button
                  v-if="!isDeliveryEstimate"
                  type="info"
                  :disabled="!selectedStores.length"
                  @click="status.selectedModalVisible = selectedStores.length"
                >
                  Selected ({{ selectedStores.length }})
                </p-button>
                <p-button
                  v-if="!isDeliveryEstimate"
                  type="purple"
                  :disabled="!searchResults.length"
                  @click="selectTop32"
                >
                  Select Top 32
                </p-button>
                <p-button
                  v-if="!isDeliveryEstimate"
                  type="yellow"
                  :disabled="!searchResults.length"
                  @click="clearSelected"
                >
                  Clear All
                </p-button>
              </div>
            </customized-form>
          </div>
        </div>
      </div>
    </div>

    <!-- NEW -->
    <div
      v-if="storeOrderingEnabled"
      id="results"
      class="row"
    >
      <div
        v-for="(storeGroup, index) in searchResults"
        :key="index"
        class="result"
        @click="$emit('select-store', storeGroup)"
      >
        <div
          v-if="!visibleStoresLimit || index < visibleStoresLimit"
          class="card store-card"
        >
          <div class="card-body">
            <div
              class="store-title h6"
              :title="storeGroup.title"
            >
              {{ storeGroup.title }}
            </div>
            <div class="store-subtitle h7">
              {{ storeGroup.subtitle }}
            </div>
            <div
              v-if="storeGroup.imageUrl"
              class="store-img"
              :style="{ 'background-image': `url(${storeGroup.imageUrl})` }"
            />
            <div
              v-else
              class="store-img"
              :style="{ 'background-image': 'url(/static/img/resto-image-not-available.jpg)' }"
            />
            <!-- Can't use the checkbox component here, because of event bubbling issues -->
            <div
              v-if="!isDeliveryEstimate"
              class="form-check checkbox"
              :class="[{ disabled: selectedStoreIds.length >= maxAllowedStores && selectedStoreIds.indexOf(storeGroup.id) === -1 }]"
            >
              <label
                class="form-check-label"
                @click.capture.stop.prevent="addOrRemoveStore(storeGroup)"
              >
                <input
                  v-model="selectedStoreIds"
                  class="form-check-input"
                  type="checkbox"
                  :disabled="selectedStoreIds.length >= maxAllowedStores && selectedStoreIds.indexOf(storeGroup.id) === -1"
                  :value="storeGroup.id"
                >
                <span class="form-check-sign" />
                <slot />
              </label>
            </div>
            <div class="promotions-block">
              <div class="promotions-block__title">
                SPECIAL OFFERS:
              </div>
              <div
                v-for="(storePromotions, service) of getPromotions(storeGroup)"
                :key="service"
              >
                <div
                  v-for="(promotion, index1) in storePromotions"
                  :key="index1"
                >
                  <b>
                    {{ service }}
                  </b>
                  {{ promotion.text }}
                  <br>
                  <span>
                    {{ promotion.description }}
                  </span>
                </div>
              </div>
              <div>
                <span v-if="averageRating(storeGroup)">{{ averageRating(storeGroup) }} <i class="fa fa-star" /></span>
                <span v-if="distance(storeGroup)">&nbsp;•&nbsp;{{ distance(storeGroup) }}</span>
                <span v-if="timeEstimate(storeGroup)">&nbsp;•&nbsp;{{ timeEstimate(storeGroup) }} mins</span>
                <span v-if="priceRange(storeGroup)">&nbsp;•&nbsp;{{ priceRange(storeGroup) }}</span>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="service-row d-flex align-items-center">
                <div
                  v-for="(service, serviceIdx) in getAvailableServices(storeGroup)"
                  :key="serviceIdx"
                  :class="service.toLowerCase()"
                  class="service mr-1"
                >
                  {{ service }}
                </div>
              </div>
              <div
                v-if="storeGroup.score / scoreComparitor >= 0.65"
                class="rating high mr-2"
              >
                &bull;&nbsp;&bull;&nbsp;&bull;
              </div>
              <div
                v-if="storeGroup.score / scoreComparitor >= 0.33 && storeGroup.score / scoreComparitor < 0.65"
                class="rating medium mr-2"
              >
                &bull;&nbsp;&bull;&nbsp;<span class="grey">&bull;</span>
              </div>
              <div
                v-if="storeGroup.score / scoreComparitor < 0.33"
                class="rating low mr-2"
              >
                &bull;<span class="grey">&nbsp;&bull;&nbsp;&bull;</span>
              </div>

              <div
                class="availability"
                :class="{ open: storeGroup.isAvailable, closed: !storeGroup.isAvailable }"
              >
                {{ storeGroup.isAvailable ? 'open' : 'closed' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- OLD -->
    <div
      v-else
      id="results"
      class="row"
    >
      <div
        v-for="(storeGroup, index) in searchResults"
        :key="index"
        class="result"
        :class="{ 'col-12': activeGroup == storeGroup, 'col-6 col-md-4': activeGroup != storeGroup }"
        @click="toggleStoreGroup(storeGroup)"
      >
        <div class="card">
          <div class="card-body">
            <div
              class="store-title h6"
              :title="storeGroup.title"
            >
              {{ storeGroup.title }}
            </div>
            <div class="store-subtitle h7">
              {{ storeGroup.subtitle }}
            </div>

            <el-checkbox
              v-model="selectedStoreIds"
              class="checkbox"
              :value="storeGroup.id"
              :disabled="selectedStoreIds.length >= maxAllowedStores && selectedStoreIds.indexOf(storeGroup.id) === -1"
              @click="addOrRemoveStore(storeGroup)"
            />

            <div
              v-if="storeGroup.score / scoreComparitor >= 0.65"
              class="rating high"
            >
              &bull;&nbsp;&bull;&nbsp;&bull;
            </div>
            <div
              v-if="storeGroup.score / scoreComparitor >= 0.33 && storeGroup.score / scoreComparitor < 0.65"
              class="rating medium"
            >
              &bull;&nbsp;&bull;&nbsp;<span class="grey">&bull;</span>
            </div>
            <div
              v-if="storeGroup.score / scoreComparitor < 0.33"
              class="rating low"
            >
              &bull;<span class="grey">&nbsp;&bull;&nbsp;&bull;</span>
            </div>

            <div
              class="availability"
              :class="{ open: storeGroup.isAvailable, closed: !storeGroup.isAvailable }"
            >
              {{ storeGroup.isAvailable ? 'open' : 'closed' }}
            </div>

            <div
              v-show="activeGroup == storeGroup"
              class="table-view"
            >
              <el-table
                :data="storeGroup.stores"
                border
                fit
                height="150"
              >
                <el-table-column
                  v-for="(item, columnIdx) in locationsTableColumns"
                  :key="columnIdx"
                  :prop="item.field"
                  :label="item.label"
                  :formatter="item.formatter"
                />

                <el-table-column
                  align="right"
                  label=""
                >
                  <template #default="scope">
                    <el-button
                      size="small"
                      @click="openUrl(scope.row.url)"
                    >
                      Website
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="status.hasNoResult"
      class="no-result-msg"
    >
      <div class="text-center h5">
        Sorry, it looks like there is no availability near that address.
      </div>
      <div class="text-center msg">
        Please use a different address or try your search again later.
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, toRefs, Ref, reactive, watch, computed, onMounted } from 'vue';
import { get, pick } from 'lodash';
import delay from 'yoctodelay';
import Moment from 'moment-timezone';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useProfile } from '@/use/profile';
import { useAddress } from '@/use/address';
import { useSwalDialog } from '@/use/swalDialog';
import { useGourmet } from '@/use/gourmet';
import { TableColumnType } from '@/models/table';
import { GeoLocationType, LocationDataType, CustomLocationType } from '@/models/address';
import { Mailing } from '@/models/marketing';
import { gourmetService } from '@/services/gourmet';
import { marketingService } from '@/services/marketing';

const chromeExtensionId = 'joanepikgpnfagfcpfipoieilpmgmidf';
const printMenuServiceNames = [
  {
    longName: 'ubereats',
    shortName: 'UE',
  },
  {
    longName: 'doordash',
    shortName: 'DD',
  },
  {
    longName: 'grubhub',
    shortName: 'GH',
  },
  {
    longName: 'postmates',
    shortName: 'PM',
  },
];
const maxAllowedStores = 32;
const maxAllowedMenus = 10;

export default {
  name: 'StoreSearch',

  props: {
    isDeliveryEstimate: {
      type: Boolean,
      default: false,
    },
    visibleStoresLimit: {
      type: Number,
      default: 0,
    },
  },

  emits: ['select-store', 'set-address', 'set-delivery-instructions', 'set-total-stores'],

  setup: (props: any, context: any) => {
    const { emit } = context;

    const { customerInfo, anchorBound } = useCustomer();
    const { userRoles } = useProfile();
    const { isGourmetOperator, isPartnerAdmin } = toRefs(userRoles);
    const {
      getFormattedAddress,
      updateAddressWithGeocode,
      parseAddressComponentsToAddress,
      checkForAddressDeliverability,
      registrationStartAddress,
    } = useAddress();
    const { showErrorPopupDialog, showWarningPopupDialog } = useSwalDialog();
    const { gourmetRegistrationStoreNames } = useGourmet();

    const requestBody = reactive({
      phoneNumber: '',
      deliveryAddress: '',
      streetAddress2: '',
      noteToDriver: '',
      mailingAddress: {
        firstName: '',
        lastName: '',
        streetAddress: '',
        streetAddress2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
      },
      email: '',
      callerId: '',
      printList: true,
    });
    const deliveryAddress: Ref<any> = ref({
      name: '',
      streetAddress: '',
      streetAddress1: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      latitude: null,
      longitude: null,
      type: false,
    });
    const searchResults: Ref<any[]> = ref([]);
    const scoreComparitor = ref(0);
    const searchQuery = ref('');
    const activeGroup: Ref<any> = ref(null);
    const selectedStores: Ref<any> = ref([]);
    const selectedStoreIds: Ref<any> = ref([]);
    const services: Ref<any> = ref(['doordash']);
    const deliveryAddressComponent: Ref<any> = ref({});
    const marker: Ref<any> = ref({
      position: {
        lat: 0.0,
        lng: 0.0,
      },
      initialPosition: {
        lat: 0.0,
        lng: 0.0,
      },
      index: 0,
      isDraggable: true,
      isShow: false,
      icon: '/static/img/pickup_marker.png',
    });
    const mapCenter: Ref<GeoLocationType> = ref({
      lat: 37.42248,
      lng: -122.08547,
    });
    const locationsTableColumns: Ref<TableColumnType[]> = ref([]);
    const status = reactive({
      isLoadingSearch: false,
      isLoadingPrint: false,
      hasNoResult: false,
      resultHtml: '',
      selectedModalVisible: false,
      selectedEmail: true,
      selectedMail: true,
      accessibleEmail: true,
      modalState: 'selected',
      loadingMessage: '',
      isAddressChanged: false,
      isEmailValid: true,
    });
    const mailingsSentToCustomer: Ref<Mailing[]> = ref([]);

    const storeOrderingEnabled = computed(() => isGourmetOperator.value || isPartnerAdmin.value || props.isDeliveryEstimate);

    const sentEmailMailText = computed(() => {
      if (status.selectedMail && status.selectedEmail) {
        return "The customer's menu has been queued to print. It may take 4 to 6 business 6 days for them to receive their menu. \n Your email has been queued and will be sent soon!";
      } else if (status.selectedEmail) {
        return 'Your email has been queued and will be sent soon!';
      } else if (status.selectedMail) {
        return "The customer's menu has been queued to print. It may take 4 to 6 business 6 days for them to receive their menu.";
      }

      return '';
    });

    const updateEmailValidation = (value: boolean) => {
      status.isEmailValid = value;
    };

    const openUrl = (url: string) => {
      const values: any = {
        action: 'setAddress',
        value: deliveryAddress.value,
      };

      // GrubHub is a special case
      if (url.search('grubhub.com') !== -1) {
        values.goToUrl = url;
        url = 'https://www.grubhub.com/search';
      }

      if (url.search('ubereats.com') !== -1) {
        values.clickFirst = true;
      }

      // Tell the extension to set the address
      chrome.runtime.sendMessage(chromeExtensionId, values, () => {
        window.open(url, '_blank');
      });
    };

    const setCallerAddresses = (address: any = null) => {
      if (address) {
        requestBody.deliveryAddress = address.streetAddress ? getFormattedAddress(address) : '';
        requestBody.streetAddress2 = address.streetAddress2;
        requestBody.noteToDriver = address.noteToDriver || '';
      } else {
        requestBody.deliveryAddress = customerInfo.value.streetAddress ? getFormattedAddress(customerInfo.value) : '';
        requestBody.streetAddress2 = customerInfo.value.streetAddress2;
        requestBody.noteToDriver = customerInfo.value.gourmetHomeNote || '';
      }

      requestBody.mailingAddress = {
        firstName: customerInfo.value.firstName,
        lastName: customerInfo.value.lastName,
        streetAddress: customerInfo.value.mailingStreetAddress || customerInfo.value.streetAddress,
        streetAddress2: customerInfo.value.mailingStreetAddress2 || customerInfo.value.streetAddress2,
        city: customerInfo.value.mailingCity || customerInfo.value.city,
        state: customerInfo.value.mailingState || customerInfo.value.state,
        zip: customerInfo.value.mailingZip || customerInfo.value.zip,
        country: customerInfo.value.mailingCountry || customerInfo.value.country,
      };
      status.isAddressChanged = true;
    };

    const setDeliveryAddress = (data: any) => {
      if (!data) {
        clearDeliveryAddress();
        return;
      }

      const addressComponents = parseAddressComponentsToAddress(data.address_components) as LocationDataType;

      const formattedDeliveryAddress = getFormattedAddress({
        streetAddress: addressComponents.route ? `${addressComponents.streetNumber} ${addressComponents.route}` : '',
        city: addressComponents.city,
        state: addressComponents.state,
        zip: addressComponents.zip,
        country: addressComponents.country || '',
      });

      // can not use data.formatted_address because it's in abbreviated form
      const isCallerDeliveryAddress = formattedDeliveryAddress.includes(requestBody.deliveryAddress);

      deliveryAddress.value = {
        placeId: data.place_id,
        latitude: data.geometry.location.lat(),
        longitude: data.geometry.location.lng(),
        name: addressComponents.streetAddress,
        formattedAddress: data.formatted_address,
        streetNumber: addressComponents.streetNumber,
        streetAddress2: isCallerDeliveryAddress ? requestBody.streetAddress2 : '',
        zip: addressComponents.zip,
        streetAddress: addressComponents.streetAddress,
        state: addressComponents.state,
        city: addressComponents.city,
        country: addressComponents.country,
      };

      emit('set-address', deliveryAddress.value);

      const deliveryInstructions = isCallerDeliveryAddress ? requestBody.noteToDriver : '';
      emit('set-delivery-instructions', deliveryInstructions);
    };

    const setAddressData = (address: CustomLocationType | null) => {
      status.isAddressChanged = true;
      requestBody.mailingAddress = {
        firstName: requestBody.mailingAddress.firstName,
        lastName: requestBody.mailingAddress.lastName,
        streetAddress: `${address?.streetNumber} ${address?.route}`,
        streetAddress2: '',
        city: address?.city || '',
        state: address?.state || '',
        zip: address?.zip || '',
        country: address?.country || 'US',
      };
    };

    const beforeModalClose = (done: any) => {
      status.modalState = 'selected';
      requestBody.printList = true;
      done();
    };

    const selectTop32 = () => {
      const selectCount = maxAllowedStores - selectedStores.value.length;

      if (!selectCount) {
        return;
      }

      const unSelectedStores = searchResults.value.filter((store: any) => selectedStores.value.indexOf(store) === -1);

      const additionalStores = unSelectedStores.slice(0, selectCount);
      selectedStores.value = selectedStores.value.concat(additionalStores);
      selectedStoreIds.value = selectedStoreIds.value.concat(additionalStores.map((s: any) => s.id));

      status.selectedModalVisible = true;
    };

    const clearSelected = (clearResults: boolean = true) => {
      if (clearResults) {
        searchResults.value = [];
        emit('set-total-stores', 0);
      }
      selectedStores.value = [];
      selectedStoreIds.value = [];
    };

    const removeStore = (index: number) => {
      selectedStores.value[index].printMenu = false;
      selectedStores.value.splice(index, 1);
      selectedStoreIds.value.splice(index, 1);
    };

    const addOrRemoveStore = (storeGroup: any) => {
      const index = selectedStores.value.findIndex((element: any) => element.id === storeGroup.id);

      if (index !== -1) {
        removeStore(index);
      } else {
        selectedStoreIds.value.push(storeGroup.id);
        selectedStores.value.push(storeGroup);
      }
    };

    const isPrintServiceSelected = (index: number, service: string) => {
      const storeMatch = selectedStores.value[index].stores.findIndex((store: any) => {
        return store.service === service && store.printMenu;
      });

      return Boolean(storeMatch !== -1);
    };

    const setPrintServiceSelected = (index: number, service: string) => {
      selectedStores.value[index].stores.forEach((store: any) => {
        if (store.service === service) {
          store.printMenu = store.printMenu ? false : true;
        }
      });
    };

    const toggleStoreGroup = (storeGroup: object) => {
      if (activeGroup.value === storeGroup) {
        activeGroup.value = null;
      } else {
        activeGroup.value = storeGroup;
      }
    };

    const onSearch = async () => {
      status.isLoadingSearch = true;
      status.resultHtml = '';
      status.hasNoResult = false;
      searchResults.value = [];

      emit('set-total-stores', 0);

      await delay(4000);
      doSearch();
    };

    const doSearch = async () => {
      if (!deliveryAddress.value) {
        status.isLoadingSearch = false;
        status.resultHtml = util.getErrorResponse({
          message: 'You must select the delivery address from the dropdown',
        });

        return;
      }

      const address = pick(deliveryAddress.value, [
        'name',
        'streetAddress',
        'streetAddress2',
        'streetNumber',
        'city',
        'state',
        'postalCode',
        'zip',
        'country',
        'formattedAddress',
        'placeId',
        'latitude',
        'longitude',
      ]);

      if (!address.postalCode || address.zip) {
        address.postalCode = deliveryAddress.value.zip;
        delete address.zip;
      }

      waitAndShowWarning();

      try {
        const response = await gourmetService.getStores({
          address,
          query: searchQuery.value,
          group: true,
          services: services.value,
        });

        scoreComparitor.value = ((response.meta.avgScore ?? 0) + (response.meta.maxScore ?? 0)) / 2;
        searchResults.value = response.stores;

        emit('set-total-stores', searchResults.value.length);

        if (props.isDeliveryEstimate && response.stores?.length) {
          const storeNames = response.stores.slice(0, 3).map((store: any) => store.title);
          gourmetRegistrationStoreNames.value = storeNames;
        }

        if (!response.stores || response.stores.length < 1) {
          status.hasNoResult = true;
        }

        const failures = response.status.failures;

        if (failures.length) {
          status.resultHtml = util.getErrorResponse({
            message: `Failed to load: ${failures.join(', ')}`,
          });
        }
      } catch (error) {
        status.resultHtml = util.getGraphqlError(error);
      }

      clearSelected(false);
      status.isLoadingSearch = false;
    };

    const onPrint = async () => {
      status.resultHtml = '';
      status.isLoadingPrint = true;
      try {
        if (status.isAddressChanged) {
          status.isAddressChanged = false;
          status.loadingMessage = 'Verifying Address...';

          await checkForAddressDeliverability(requestBody.mailingAddress);
        }

        const isValidToSendMail = await validateToPrintStores();

        if (!isValidToSendMail) {
          status.isLoadingPrint = false;
          status.selectedModalVisible = false;
          status.modalState = 'selected';
          return;
        }

        status.loadingMessage = 'Queuing printing...';

        const response = await gourmetService.printStores({
          mailing: status.selectedMail
            ? {
                streetAddress: requestBody.mailingAddress.streetAddress,
                streetAddress2: requestBody.mailingAddress.streetAddress2,
                city: requestBody.mailingAddress.city,
                zip: requestBody.mailingAddress.zip,
                state: requestBody.mailingAddress.state,
                type: 'gourmet-restaurants',
              }
            : null,
          email: status.selectedEmail ? requestBody.email : null,
          accessibleEmail: status.accessibleEmail || null,
          userId: requestBody.callerId || null,
          firstName: requestBody.mailingAddress.firstName,
          printList: requestBody.printList,
          stores: selectedStores.value,
        });

        if (response) {
          status.modalState = 'sent';
        }
      } catch (error) {
        const errorText = util.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      }
      status.isLoadingPrint = false;
    };

    const getAvailableServices = (storeGroup: any) => {
      const availableServices: string[] = [];

      storeGroup.stores.forEach((subStore: any) => {
        const serviceName = printMenuServiceNames.find((service) => service.longName === subStore.service);
        const serviceShortName = serviceName && serviceName.shortName;

        if (serviceShortName && !availableServices.includes(serviceShortName)) {
          availableServices.push(serviceShortName);
        }
      });

      return availableServices.sort();
    };

    const getPromotions = (storeGroup: any) => {
      const promotions = {} as any;
      const stores = get(storeGroup, 'stores', []);

      stores.forEach((s: any) => {
        const promotion = s.promotion;
        const service = s.service === 'doordash' ? 'DD' : 'UE';
        if (promotion && !promotions[service]) {
          promotions[service] = {};
        }
        if (promotion && promotion.text && !promotions[service][promotion.text]) {
          promotions[service][promotion.text] = promotion;
        }
      });

      return Object.keys(promotions).length ? promotions : null;
    };

    const distance = (storeGroup: any) => {
      if (!storeGroup.stores?.length) {
        return null;
      }

      return storeGroup.stores[0].distance;
    };

    const averageRating = (storeGroup: any) => {
      if (!storeGroup.stores?.length) {
        return null;
      }

      const averageRating = storeGroup.stores[0].averageRating;

      if (!averageRating) {
        return null;
      }

      return averageRating.toFixed(1);
    };

    const timeEstimate = (storeGroup: any) => {
      if (!storeGroup.stores?.length) {
        return null;
      }

      const timeEstimate = storeGroup.stores[0].timeEstimate;

      if (!timeEstimate) {
        return null;
      }

      if (timeEstimate.min === timeEstimate.max) {
        return timeEstimate.min;
      }

      return [timeEstimate.min, timeEstimate.max].filter((time) => time).join(' ~ ');
    };

    const priceRange = (storeGroup: any) => {
      if (!storeGroup.stores?.length) {
        return null;
      }

      const priceRange = storeGroup.stores[0].priceRange || 0;

      let priceRangeString = '';

      for (let i = 0; i < priceRange; i += 1) {
        priceRangeString += '$';
      }

      return priceRangeString;
    };

    const setMarkerPosition = (
      lat: number | string | null,
      lng: number | string | null,
      index: number,
      isMarkerChanged: boolean = true,
      isAddressChanged: boolean = false,
    ) => {
      util.updateMarkerPosition(marker.value, lat, lng, isAddressChanged);

      mapCenter.value = {
        lat: Number(lat) || mapCenter.value.lat,
        lng: Number(lng) || mapCenter.value.lng,
      };

      if (isMarkerChanged) {
        deliveryAddress.value = updateAddressWithGeocode(deliveryAddress.value, lat, lng);

        emit('set-address', deliveryAddress.value);
      }
    };

    const dragMapPin = () => {
      if (!customerInfo.value?.id) {
        return;
      }

      deliveryAddressComponent.value.showSaveCustomLocationDialog();
    };

    const onChooseCallerLocation = (address: any) => {
      setCallerAddresses(address);
      clearDeliveryAddress();

      deliveryAddress.value = {
        placeId: address.googlePlaceId,
        latitude: address.latitude ? Number(address.latitude) : null,
        longitude: address.longitude ? Number(address.longitude) : null,
        name: address.name,
        formattedAddress: address.formattedAddress || getFormattedAddress(address),
        streetNumber: address.streetNumber,
        streetAddress2: address.streetAddress2,
        zip: address.zip,
        streetAddress: address.streetAddress,
        state: address.state,
        city: address.city,
        country: address.country,
      };

      emit('set-address', deliveryAddress.value);
    };

    const waitAndShowWarning = async () => {
      await delay(15000);

      if (status.isLoadingSearch) {
        status.isLoadingSearch = false;
        status.resultHtml = util.getErrorResponse({
          message: 'Slow network connection. Please wait a few seconds and retry.',
        });
      }
    };

    const clearDeliveryAddress = () => {
      deliveryAddress.value = {
        placeId: '',
        latitude: 0,
        longitude: 0,
        name: '',
        formattedAddress: '',
        streetNumber: '',
        streetAddress2: '',
        zip: '',
        streetAddress: '',
        state: '',
        city: '',
        country: '',
      };
    };

    const getMailingsSentToCustomer = async () => {
      try {
        const response = await marketingService.getMailings({
          searchType: 'phone-number',
          phoneNumber: customerInfo.value.phoneNumber,
          mailingTypes: ['gourmet-restaurants'],
          pagination: {
            offset: 0,
            limit: 5,
          },
        });

        mailingsSentToCustomer.value = response.rows;
      } catch (error) {
        console.log(util.getGraphqlError(error, false));
      }
    };

    const validateToPrintStores = async () => {
      if (!status.selectedMail) {
        return true;
      }

      if (!customerInfo.value?.id) {
        return true;
      }

      if (mailingsSentToCustomer.value.length === 0) {
        return true;
      }

      const before10Days = Moment.utc().subtract(10, 'days');
      const mailingsSentIn10Days = mailingsSentToCustomer.value.find((item: Mailing) => Moment.utc(item.sentAt).isAfter(before10Days));

      if (mailingsSentIn10Days) {
        showWarningPopupDialog({
          text: 'Please inform the customer that a menu was mailed recently and to please allow 5-10 business days to arrive',
          title: 'Reminder',
        });

        return false;
      }

      const before30Days = Moment.utc().subtract(30, 'days');
      const mailingsSentIn30Days = mailingsSentToCustomer.value.filter((item: Mailing) => Moment.utc(item.sentAt).isAfter(before30Days));

      if (mailingsSentIn30Days.length >= 2) {
        showWarningPopupDialog({
          text: "Looks like we've already mailed this customer two sets of menus in the past 30 days. Please verify the delivery address. Please inform your TL if there are any issues with the delivery address",
          title: 'Sorry!',
        });

        return false;
      }

      return true;
    };

    watch(
      customerInfo,
      (value: any) => {
        mailingsSentToCustomer.value = [];
        if (value.id) {
          requestBody.callerId = value.id;
          requestBody.email = value.email;
          setCallerAddresses();
          getMailingsSentToCustomer();
        }
      },
      {
        immediate: true,
      },
    );

    watch(deliveryAddress, (value: any, oldValue: any) => {
      const isAddressChanged = util.isAddressChanged(value, oldValue);
      setMarkerPosition(Number(value.latitude), Number(value.longitude), 0, false, isAddressChanged);
    });

    onMounted(() => {
      locationsTableColumns.value = [
        { label: 'Service', field: 'service' },
        { label: 'Name', field: 'title' },
        {
          label: 'Open',
          field: 'isAvailable',
          formatter: (row: any) => {
            return row?.isAvailable ? 'Yes' : 'No';
          },
        },
        {
          label: 'Service Fee',
          field: 'serviceFee',
          formatter: (row: any) => {
            return row?.serviceFee && `$${(row.serviceFee / 100).toFixed(2)}`;
          },
        },
        {
          label: 'Time Estimate',
          field: 'timeEstimate',
          formatter: (row: any) => {
            return (
              row?.timeEstimate?.min &&
              row?.timeEstimate?.min &&
              `${
                row.timeEstimate.min === row.timeEstimate.max ? row.timeEstimate.min : `${row.timeEstimate.min} - ${row.timeEstimate.max}`
              } mins`
            );
          },
        },
      ];

      if (props.isDeliveryEstimate && registrationStartAddress.value) {
        deliveryAddress.value = {
          placeId: registrationStartAddress.value.placeId,
          latitude: registrationStartAddress.value.latitude,
          longitude: registrationStartAddress.value.longitude,
          name: registrationStartAddress.value.name,
          formattedAddress: registrationStartAddress.value.formattedAddress,
          streetAddress2: registrationStartAddress.value.streetAddress2,
          zip: registrationStartAddress.value.zip,
          streetAddress: registrationStartAddress.value.streetAddress,
          state: registrationStartAddress.value.state,
          city: registrationStartAddress.value.city,
          country: registrationStartAddress.value.country,
        };

        emit('set-address', deliveryAddress.value);
      }
    });

    return {
      printMenuServiceNames,
      maxAllowedStores,
      maxAllowedMenus,
      customerInfo,
      requestBody,
      deliveryAddress,
      searchResults,
      scoreComparitor,
      searchQuery,
      activeGroup,
      selectedStores,
      selectedStoreIds,
      services,
      deliveryAddressComponent,
      marker,
      mapCenter,
      locationsTableColumns,
      status,
      storeOrderingEnabled,
      anchorBound,
      distance,
      averageRating,
      timeEstimate,
      priceRange,
      mailingsSentToCustomer,
      updateEmailValidation,

      util,

      openUrl,
      setDeliveryAddress,
      setAddressData,
      beforeModalClose,
      selectTop32,
      clearSelected,
      removeStore,
      addOrRemoveStore,
      isPrintServiceSelected,
      setPrintServiceSelected,
      toggleStoreGroup,
      onSearch,
      onPrint,
      getAvailableServices,
      getPromotions,
      setMarkerPosition,
      dragMapPin,
      onChooseCallerLocation,
      sentEmailMailText,
    };
  },
};
</script>

<style lang="scss">
.page-content.store-search {
  .el-table table .checkbox {
    width: auto;
  }

  .el-dialog {
    width: 50% !important;
    @media (max-width: 576px) {
      width: 100% !important;
    }

    .form-vertical {
      .check-email {
        margin-left: 15px;
      }
      .check-mail {
        margin-left: 45px;
      }
      .check-include-restaurant {
        margin-left: 25%;
        padding: 0 1rem;
      }
    }

    .sent-message {
      white-space: pre-line;
      margin-left: auto;
      margin-right: auto;
      width: fit-content;
    }
  }

  button {
    min-width: auto;
  }

  .row.search-form {
    margin-bottom: 0;
  }

  .search-form {
    .card-content {
      text-align: center;
      form {
        width: 700px;
        display: inline-block;
      }
    }
  }

  .card {
    border-radius: 5px;
  }

  #results {
    justify-content: center;
    .card {
      min-height: 150px;
      border-radius: 5px;

      .checkbox {
        position: absolute;
        right: -4px;
        top: -8px;

        .form-check-label {
          input[type='checkbox'] {
            &:checked + .form-check-sign:before {
              background-color: #008000;
            }
          }

          .form-check-sign {
            &:before {
              background-color: #ddd;
              border-radius: 50%;
            }

            &:after {
              opacity: 1;
            }
          }
        }
      }

      .store-title {
        height: 32px;
        overflow: hidden;
        padding-right: 25px;
      }

      .store-img {
        height: 210px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }

      .store-subtitle {
        height: 65px;
        display: block;
        overflow: hidden;
      }

      .service-row {
        flex: 1 1 auto;

        .service {
          font-weight: bold;
        }

        .ue {
          color: blue;
        }

        .dd {
          color: red;
        }

        .gh {
          color: black;
        }

        .pm {
          color: green;
        }
      }

      .rating {
        &.high {
          color: green;
        }

        &.medium {
          color: orange;
        }

        &.low {
          color: red;
        }

        .grey {
          color: grey;
        }
      }

      .promotions-block {
        height: 75px;
        padding: 6px;
        margin-top: 4px;
        overflow: scroll;
        &__title {
          text-align: left;
          font-size: 13px;
          font-weight: bold;
          width: 100%;
        }
        &::-webkit-scrollbar {
          -webkit-appearance: none;
          width: 5px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background-color: rgba(0, 0, 0, 0.5);
          -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
        }
      }

      .availability {
        background-color: green;
        color: white;
        padding: 0 5px;
        font-size: 12px;

        &.closed {
          background-color: red;
        }
      }
    }
    .store-card {
      width: 250px;
      margin-right: 10px;
    }
  }

  .no-result-msg {
    margin-top: 50px;

    .h5 {
      margin-bottom: 10px;
    }

    .msg {
      font-size: 17px;
    }
  }

  .el-loading-mask {
    text-align: center !important;
  }
}

.delivery-detail-popover {
  ul {
    padding-left: 20px;
  }
}

.search-settings {
  width: 550px;
  text-align: left;
  margin-left: auto;
  margin-top: 10px;
  font-size: 20px;
  z-index: 0;
  .el-checkbox__label {
    font-size: 15px;
  }
  .el-checkbox-group .el-checkbox__label {
    position: relative;
    top: 2px;
  }
  &__message {
    font-size: 14px;
  }
}
</style>
